import React from "react";

type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?:"submit" | "reset" | "button" | undefined;
};

const Button = ({ children, onClick, disabled = false, type=undefined,className = "" }: ButtonProps) => {
  return (
    <button
      className={` font-bold py-2 px-6 rounded-full ${className}  `}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {children}
    </button>
  );
};
// bg-[linear-gradient(101deg,_#007DFC_-2.49%,_#0056FC_100%)]
export default Button;
